import "@/App.css";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import CustomCursor from "@/components/CustomCursor";
import CookieConsent from "@/components/CookieConsent";
import AdminDashboardPage from "@/pages/AdminDashboardPage";
import DarkMapPreviewPage from "@/pages/DarkMapPreviewPage";
import HomePage from "@/pages/HomePage";
import LoginPage from "@/pages/LoginPage";
import NotFoundPage from "@/pages/NotFoundPage";

function App() {
  return (
    <div className="App" data-testid="app-shell">
      <CustomCursor />
      <CookieConsent />
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/admin" element={<LoginPage />} />
          <Route path="/admin/oversikt" element={<AdminDashboardPage />} />
          <Route path="/contact-map-dark-preview" element={<DarkMapPreviewPage />} />
          <Route path="*" element={<NotFoundPage />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
